<template>
<div class="chapter">
<div class="inner_page">
<p><a id="toc"></a></p>
<div class="fmh1">Table of Contents</div>
<div> <br/></div>
<div class="cfmh"><a href="#/henn_9781595585820_oeb_fm1_r1">ALSO BY HENNING MANKELL</a></div>
<div class="cfmh"><a href="#/henn_9781595585820_oeb_tp_r1">Title Page</a></div>
<div class="cfmh"><a href="#/henn_9781595585820_oeb_ded_r1">Dedication</a></div>
<div class="cfmh"><a href="#/henn_9781595585820_oeb_frw_r1">Foreword</a></div>
<div> <br/></div>
<div class="cpt"><a href="#/henn_9781595585820_oeb_p01_r1">Wallander’s First Case</a></div>
<div class="cct"><a href="#/henn_9781595585820_oeb_c01_r1">Chapter 1</a></div>
<div class="cct"><a href="#/henn_9781595585820_oeb_c02_r1">Chapter 2</a></div>
<div class="cct"><span href="#/henn_9781595585820_oeb_c03_r1" title="Link target outside of Sample">Chapter 3</span></div>
<div class="cct"><span href="#/henn_9781595585820_oeb_c04_r1" title="Link target outside of Sample">Epilogue</span></div>
<div> <br/></div>
<div class="cpt"><span href="#/henn_9781595585820_oeb_p02_r1" title="Link target outside of Sample">The Man with the Mask</span></div>
<div> <br/></div>
<div class="cpt"><span href="#/henn_9781595585820_oeb_p03_r1" title="Link target outside of Sample">The Man on the Beach</span></div>
<div> <br/></div>
<div class="cpt"><span href="#/henn_9781595585820_oeb_p04_r1" title="Link target outside of Sample">The Death of the Photographer</span></div>
<div> <br/></div>
<div class="cpt"><span href="#/henn_9781595585820_oeb_p05_r1" title="Link target outside of Sample">The Pyramid</span></div>
<div class="cct"><span href="#/henn_9781595585820_oeb_c05_r1" title="Link target outside of Sample">Prologue</span></div>
<div class="cct"><span href="#/henn_9781595585820_oeb_c06_r1" title="Link target outside of Sample">Chapter 1</span></div>
<div class="cct"><span href="#/henn_9781595585820_oeb_c07_r1" title="Link target outside of Sample">Chapter 2</span></div>
<div class="cct"><span href="#/henn_9781595585820_oeb_c08_r1" title="Link target outside of Sample">Chapter 3</span></div>
<div class="cct"><span href="#/henn_9781595585820_oeb_c09_r1" title="Link target outside of Sample">Chapter 4</span></div>
<div class="cct"><span href="#/henn_9781595585820_oeb_c10_r1" title="Link target outside of Sample">Chapter 5</span></div>
<div class="cct"><span href="#/henn_9781595585820_oeb_c11_r1" title="Link target outside of Sample">Chapter 6</span></div>
<div class="cct"><span href="#/henn_9781595585820_oeb_c12_r1" title="Link target outside of Sample">Chapter 7</span></div>
<div class="cct"><span href="#/henn_9781595585820_oeb_c13_r1" title="Link target outside of Sample">Chapter 8</span></div>
<div class="cct"><span href="#/henn_9781595585820_oeb_c14_r1" title="Link target outside of Sample">Chapter 9</span></div>
<div class="cct"><span href="#/henn_9781595585820_oeb_c15_r1" title="Link target outside of Sample">Chapter 10</span></div>
<div class="cct"><span href="#/henn_9781595585820_oeb_c16_r1" title="Link target outside of Sample">Chapter 11</span></div>
<div class="cct"><span href="#/henn_9781595585820_oeb_c17_r1" title="Link target outside of Sample">Chapter 12</span></div>
<div> <br/></div>
<div class="cbmh"><span href="#/henn_9781595585820_oeb_elg_r1" title="Link target outside of Sample">Epilogue</span></div>
<div class="cbmh"><span href="#/henn_9781595585820_oeb_cop_r1" title="Link target outside of Sample">Copyright Page</span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// henn_9781595585820_oeb_toc_r1.vue?1e1ae396